<template>
  <div>
    <BaseDialog
      v-model="showDialog"
      :title="`#${order.componentId}`"
      :subtitle="order.componentName"
      dialogIcon="mdi-truck-delivery-outline"
      dialogBack="mdi-arrow-left"
      scrollable
      actionsColumnDirection
      closeBtnBlock
      @action="save"
    >
      <template v-slot>
        <v-textarea
          v-model="order.description"
          filled
          label="Beskrivelse"
          hide-details
          auto-grow
          disabled
        ></v-textarea>

        <v-text-field
          v-model="order.qty"
          class="mb-0"
          label="Bestilt"
          filled
          type="tel"
          hide-details
          :suffix="order.unit"
          disabled
        ></v-text-field>
        <v-banner
          v-if="!actionEnable || orderAlreadyReceived"
          class="text-center py-5"
        >
          <v-icon slot="icon" color="warning" x-large hide-details
            >mdi-alert-outline </v-icon
          >{{ getBannerText }}</v-banner
        >
      </template>
      <template v-if="actionEnable && !orderAlreadyReceived" v-slot:btn>
        <div class="mt-6 fullWidth">
          <v-slider
            v-model="getformattedtextQty"
            :step="getOrderStep"
            :min="getOrderQtyReceived"
            :max="getOrderMaxQty"
            color="primary"
            thumb-label="always"
          ></v-slider>
        </div>

        <v-card class="pa-2 mb-6 mt-2 fullWidth" color="secondary">
          <div class="d-flex justify-space-between">
            <v-btn
              class="mr-3"
              color="primary"
              depressed
              fab
              :ripple="false"
              @click="decrementSlider"
            >
              <v-icon> mdi-minus </v-icon>
            </v-btn>
            <div class="mlr-5">
              <v-text-field
                v-model="getformattedtextQty"
                class="mb-0"
                label="Levert"
                background-color="input"
                filled
                flat
                hide-details
                :suffix="order.unit"
                @keyup.up="onPressUpKey"
                @keyup.down="onPressDownKey"
                @keydown="handelKeydown"
              ></v-text-field>
            </div>
            <v-btn
              fab
              class="ml-3"
              color="primary"
              depressed
              :ripple="false"
              @click="incrementSlider"
            >
              <v-icon> mdi-plus </v-icon>
            </v-btn>
          </div>
        </v-card>

        <div class="fullWidth">
          <v-btn
            class="mb-4"
            color="primary"
            depressed
            large
            block
            @click="confirmReceivedgoodsAction()"
          >
            Bekreft
          </v-btn>
        </div>
      </template>
    </BaseDialog>

    <ConfirmDialog
      v-model="showConfirmReceivegood"
      title="Bekreft varemottak handling"
      icon="mdi-clipboard-check-outline"
      :text="getConfirmRegeivedgoodText"
      btnActionName="Ja"
      btnCloseName="Nei"
      :showContent="true"
      @action="updateOrderGoods()"
    >
      <!-- <template v-slot:transitionBtn>
        <v-slide-y-transition>
          <v-btn
            v-show="$vuetify.breakpoint.mobile && showTransitionBtn"
            fixed
            color="primary"
            large
            depressed
            block
            class="mb-2 topTransitonBtn"
            @click="updateOrderGoods()"
            >Bekreft</v-btn
          >
        </v-slide-y-transition>
      </template> -->

      <template v-slot:contentElement>
        <div class="ma-2 pa-2">
          <v-radio-group v-model="getselectedAction">
            <v-radio
              v-for="n in 2"
              :key="n"
              :disabled="n === 2 && disableAction"
              :value="n"
              :label="
                n === 1
                  ? 'Rapporter fullt mottak (Korriger ant. i bestilling)'
                  : 'Rapporter delmottak'
              "
            >
            </v-radio>
          </v-radio-group>
        </div>
      </template>
    </ConfirmDialog>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import api from "@/api/api";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import { OrderLines } from "@/types/orderInterface";
import notification from "@/helpers/notification";

import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";
import ConfirmDialog from "@/components/shared/dialog/ConfirmDialog.vue";

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    order: {
      type: Object as () => OrderLines,
    },
    actionEnable: {
      type: Boolean,
    },
    goodsNotReceived: {
      type: Boolean,
    },
    orderAlreadyReceived: {
      type: Boolean,
    },
  },
  data() {
    return {
      showConfirmReceivegood: false as boolean,
      selectedAction: 0 as number, //default fullmottak
      selectedActionText: [
        "fullt mottak",
        "fullt mottak (Korriger ant. i bestilling)",
        "delmottak",
      ],
      valid: false,
      dateRules: [
        (v) => !!v || "Utstedt dato må fylles ut!",
        (v) =>
          moment(moment(v).add(2, "years").format("YYYY-MM-DD")).isBefore(
            moment().format("YYYY-MM-DD")
          ) === false || "Kortet kan ikke være utstedt for mere en 2 år siden!",
      ],
      moment,
      textQty: "0",
      slider: 0 as number,
    };
  },
  methods: {
    ...mapActions({
      updateProfile: "shared/updateProfile",
    }),
    async save() {
      const isValid = (this as any).$refs?.form?.validate();

      if (isValid) {
        await api.putContactPerson(this.profile).then((Response) => {
          this.updateProfile(Response);
          this.showDialog = false;
        });
      } else {
        notification.warn("Alle felter må fylles ut!");
      }
    },
    initializeValue() {
      this.textQty = this.getOrderQty.toString();
    },
    initializeActions() {
      if (Number(this.textQty) > this.getOrderQty) {
        this.getselectedAction = 1; //Korriger ant. i bestilling
      } else {
        this.getselectedAction = 2; //rapporter delmottak
      }
    },
    decrementSlider() {
      let val = Number(this.textQty) - Number(this.getOrderStep);
      this.getformattedtextQty = val < 0 ? "0" : val.toString();
    },
    incrementSlider() {
      let val = Number(this.textQty) + Number(this.getOrderStep);
      this.getformattedtextQty = val.toString();
    },
    onPressUpKey(e) {
      if (e.key != "ArrowUp") return;
      this.incrementSlider();
    },
    onPressDownKey(e) {
      if (e.key != "ArrowDown") return;
      this.decrementSlider();
    },
    handelKeydown(e) {
      if (e.which == 38 || e.which == 40) {
        e.preventDefault();
      }
    },
    confirmReceivedgoodsAction() {
      if (this.order.qty === Number(this.textQty)) {
        this.getselectedAction = 0; //full mottak
        this.updateOrderGoods();
      } else {
        this.initializeActions();
        this.showConfirmReceivegood = true;
      }
    },
    updateOrderGoods() {
      this.$emit(
        "updateOrderInfo",
        this.order.componentId,
        this.textQty,
        this.selectedAction
      );

      this.showConfirmReceivegood = false;
      this.showDialog = false;
    },
  },

  computed: {
    ...mapGetters({
      profile: "shared/profile",
    }),
    getBannerText(): string {
      if (this.orderAlreadyReceived || !this.goodsNotReceived) {
        return "Ordre har allerede mottatt bestilte varer.";
      } else {
        return "Ordre må ha status som frigitt eller åpent for å kunne bekrefte varemottak handlinger.";
      }
    },
    getselectedAction: {
      get(): number {
        return this.selectedAction;
      },
      set(value: number) {
        this.selectedAction = value;
      },
    },
    disableAction(): boolean {
      if (Number(this.textQty) > this.getOrderQty) {
        return true;
      } else {
        return false;
      }
    },
    getformattedtextQty: {
      get(): string {
        return this.textQty;
      },
      set(value: string) {
        // let val = value.toString().replace(/\D/g, "").replace(/,/g, ".");
        // this.textQty = val;
        this.textQty =
          Number(value) > this.getOrderMaxQty
            ? this.getOrderMaxQty.toString()
            : value;
      },
    },
    // getFormattedSlider: {
    //   get() {
    //     if (this.getOrderStep && this.getOrderStep < 1) {
    //       return new Intl.NumberFormat("no-No", {
    //         minimumFractionDigits: 2,
    //       }).format(this.getslider as number);
    //     } else {
    //       return new Intl.NumberFormat("no-No", {
    //         minimumFractionDigits: 0,
    //       }).format(this.getslider as number);
    //     }
    //   },
    //   set(data: string) {
    //     clearTimeout(this.timer);
    //     this.timer = setTimeout(() => {
    //       this.getslider = isNaN(Number(data))
    //         ? Number(data.replace(/\D/g, ""))
    //         : Number(data);
    //     }, 2000);
    //   },
    // },
    showDialog: {
      get(): boolean {
        if (this.value) {
          this.initializeValue();
        }
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
    getRemainingQty(): number {
      if (this.order.qty && this.order.qtyAlreadyReceived) {
        return this.order.qty - this.order.qtyAlreadyReceived;
      } else {
        return this.order.qty as number;
      }
    },
    getOrderMaxQty(): number {
      return this.getOrderQty as number;
    },
    getOrderStep(): number {
      return (this.getOrderQty as number) % 1 === 0 ? 1 : 0.01;
    },
    getOrderQty(): number {
      if (!this.order.qty) return 0;

      return this.order.qty % 1 === 0
        ? this.order.qty
        : Number(this.order.qty.toFixed(2));
    },
    getOrderQtyReceived(): number {
      if (!this.order.qtyAlreadyReceived) return 0;

      return this.order.qtyAlreadyReceived % 1 === 0
        ? this.order.qtyAlreadyReceived
        : Number(this.order.qtyAlreadyReceived.toFixed(2));
    },
    getConfirmRegeivedgoodText(): string {
      return `Vil du bekreft mottatt antallet ${this.textQty}
      som ${this.selectedActionText[this.selectedAction]} for vare ${
        this.order.componentName
      } i ordre #${this.order.componentId}.`;
    },
  },
  // watch: {
  //   textQty(val) {
  //     let data = Number(val);
  //     if (data && data <= 0) {
  //       this.getslider = this.getOrderQtyReceived;
  //       return;
  //     }
  //     if (data && data > this.getOrderMaxQty) {
  //       this.getslider = this.getOrderMaxQty;
  //       return;
  //     }
  //     this.getslider = data;
  //   },
  // },
  components: {
    BaseDialog,
    ConfirmDialog,
  },
});
</script>

<style lang="scss" scoped>
.fullWidth {
  min-width: 100%;
}

div#actions {
  padding: 2px; //t r b l
  border: 2px;
  border-radius: 12px;
  background-color: grayscale($color: #f6f6f6); //#fdb913;
}

.topTransitonBtn {
  position: -webkit-sticky;
  position: sticky;
  top: 50px;
  z-index: 2;
}
// .topTransitonBtn {
//   position: -webkit-sticky;
//   position: sticky;
//   top: 23px;
//   z-index: 2;
//   transform: translate(0rem, 0rem);
// }
</style>
